export default "__VITE_ASSET__e56a01c4__"